import { render } from "./Fab.vue?vue&type=template&id=6e4ed50c&scoped=true"
import script from "./Fab.vue?vue&type=script&lang=js"
export * from "./Fab.vue?vue&type=script&lang=js"

import "./Fab.vue?vue&type=style&index=0&id=6e4ed50c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4ed50c"]])

export default __exports__